
        <div class="jui-menu-item-group-title">
            <ng-content select="[title]"></ng-content>
        </div>
        <div class="jui-menu-item-group-list">
            <ng-content></ng-content>
        </div>
    